import { Reveal } from "./Reveal";

export const SectionHeader = ({ eyebrow, heading, subcopy, light = false, testid }) => (
  <Reveal className="max-w-2xl">
    <p className={`text-xs font-semibold uppercase tracking-[0.14em] ${light ? "text-white/70" : "text-brand"}`}>
      {eyebrow}
    </p>
    <h2
      data-testid={testid}
      className={`mt-3 font-heading text-3xl font-bold tracking-tight md:text-4xl ${
        light ? "text-white" : "text-gray-900"
      }`}
    >
      {heading}
    </h2>
    {subcopy && (
      <p className={`mt-4 text-base leading-relaxed md:text-lg ${light ? "text-white/80" : "text-gray-600"}`}>
        {subcopy}
      </p>
    )}
  </Reveal>
);
